module.exports = __webpack_public_path__ + "img/hand_shake_w.bd7746c6.svg";